import { initReactI18next } from "react-i18next";

import i18n from "i18next";
import ChainedBackend from "i18next-chained-backend";
import Backend from "i18next-http-backend";
import i18nextMiddleware from "i18next-http-middleware";
import resourcesToBackend from "i18next-resources-to-backend";

import { HOME_SSR_URL, HOME_URL } from "./utils/constants";
import { isSSR } from "./utils/helpers/isSSR";

i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  .use(i18nextMiddleware.LanguageDetector)

  .init(
    {
      initImmediate: false,
      lng: isSSR()
        ? ""
        : document.documentElement.lang !== "#htmllang"
          ? document.documentElement.lang
          : "en",
      fallbackLng: "en",

      backend: {
        backends: [
          Backend,

          // local json from src/
          // if backend fails, translations download from this
          resourcesToBackend(lng => import(`./translations/${lng}.json`)),
        ],
        backendOptions: [
          {
            //backend path
            loadPath: `${isSSR() ? HOME_SSR_URL : HOME_URL}/api/files/translations/{{lng}}.json`, //  -- backend --
          },
        ],
      },
    },

    // (err, t) => {
    //   if (err) return console.error(err);
    //
    //   console.log("i18next is ready...");
    //   console.log("Some text from translations- " + t("global.heroTitle"));
    // },
  );

export default i18n;
